<div class="container-fluid">
    <div class="d-flex justify-content-between p-1">
        <h6>Liste des élèves</h6>
        <div class="d-flex">
            <select class="mx-1" id="" (change)="changeView($event)">
                <option value="list">vue liste</option>
                <option value="photo">vue photo</option>
            </select>
            <select class="mx-1" id="" (change)="loadlist($event)">
                <option selected disabled></option>
                <option *ngFor="let c of classrooms" [value]="c.classroom?.id">{{c.classroom?.name}}</option>
            </select>
            <button *ngIf="data.length!=0" [disabled]="loading" (click)="getPdf()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                Exporter en PDF</button>
        </div>
    </div>

    <app-student-list [vue]="vue" [datas]="data" (launchEdittingEvent)="edit($event,editContent)"></app-student-list>
</div>

<ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>

<ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier la date de naissance</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3">
        
            <div class=" form-group col-12 mb-3">
                <label for="">Date de naissance <span class="text-danger ml-2">(*)</span></label>
                <input type="date" name="birthdate" class="form-control" [(ngModel)]="selected_data.student.birthdate">
            </div> 
           
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
